
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
const AuthorisedCategoryValueForm = ({
    keyPrefix = 'koha.authorized_category_management',
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const editor = useRef(null);
    const [show, setShow] = useState(true)
    const { t } = useTranslation('translation', { keyPrefix })
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // propsOnValuesChange(formValues)
    };

    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                // initialValues={initialValues}
                                show={show}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                axiosMode={axiosMode}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix,
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    axiosMode,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    
    return (
        <>
            <Row>
                <Col
                    span={
                        24
                    }
                >
                    <Form.Item
                        hidden
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'old_category']}
                        fieldKey={[field?.fieldKey ?? '', 'old_category']}
                        label={t('category')}
                        initialValue={initialValues?.old_category}
                    >
                        <Input   />
                    </Form.Item>
                </Col>
                <Col
                    span={
                        24
                    }
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'category']}
                        fieldKey={[field?.fieldKey ?? '', 'category']}
                        label={t('category')}
                        initialValue={initialValues?.category}
                    >
                        <Input disabled={axiosMode === "patch"} />
                    </Form.Item>
                </Col>
                <Col
                    span={
                        24
                    }
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'description']}
                        fieldKey={[field?.fieldKey ?? '', 'description']}
                        label={t('description')}
                        initialValue={initialValues?.description}
                    >
                        <Input   />
                    </Form.Item>
                </Col>
                
            </Row>
        </>
    );
};


export default AuthorisedCategoryValueForm;
